import {create} from "zustand";
import axios from "axios";
import config from "../config/config.json";

const BankNotificationStore = (set, get) => ({

    notifications: [],
    isLoading: false,
    error: null,
    statusFilter: null, // null = all, or "pending", "matched", "unmatched", "ignored"

    setNotifications: (newNotifications) => {
        set({notifications: newNotifications})
    },

    setStatusFilter: (status) => {
        set({statusFilter: status})
        get().loadNotifications()
    },

    loadNotifications: async () => {
        set({ isLoading: true, error: null });

        try {
            let url = config.API_URL + 'bank/notifications'
            const statusFilter = get().statusFilter
            if (statusFilter) {
                url += '?status=' + statusFilter
            }

            const response = await axios.get(url, {
                headers: {'x-api-key': sessionStorage.getItem("apiKEY")}
            });

            const data = response.data
            const newData = data.map(item => ({
                ...item,
                TransactionDate: item.TransactionDate ? new Date(item.TransactionDate) : null,
                NotificationDate: item.NotificationDate ? new Date(item.NotificationDate) : null,
                ProcessedAt: item.ProcessedAt ? new Date(item.ProcessedAt) : null,
                CreatedAt: item.CreatedAt ? new Date(item.CreatedAt) : null
            }))
            set({ notifications: newData, isLoading: false });

        } catch (error) {
            set({ error: error.message, isLoading: false });
        }
    },

    uploadPDF: async (files) => {
        set({ isLoading: true, error: null });

        try {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('files', files[i]);
            }

            const response = await axios.post(config.API_URL + 'bank/upload', formData, {
                headers: {
                    'x-api-key': sessionStorage.getItem("apiKEY"),
                    'Content-Type': 'multipart/form-data'
                }
            });

            set({ isLoading: false });
            get().loadNotifications();
            return response.data;

        } catch (error) {
            set({ error: error.message, isLoading: false });
            throw error;
        }
    },

    processAll: async () => {
        set({ isLoading: true, error: null });

        try {
            const response = await axios.post(config.API_URL + 'bank/process', {}, {
                headers: {'x-api-key': sessionStorage.getItem("apiKEY")}
            });

            set({ isLoading: false });
            get().loadNotifications();
            return response.data;

        } catch (error) {
            set({ error: error.message, isLoading: false });
            throw error;
        }
    },

    matchManually: async (notificationId, cashflowId, note = '') => {
        set({ isLoading: true, error: null });

        try {
            const response = await axios.post(
                config.API_URL + 'bank/match/' + notificationId,
                { cashflowId: cashflowId, note: note },
                { headers: {'x-api-key': sessionStorage.getItem("apiKEY")} }
            );

            set({ isLoading: false });
            get().loadNotifications();
            return response.data;

        } catch (error) {
            set({ error: error.message, isLoading: false });
            throw error;
        }
    },

    ignoreNotification: async (notificationId, note = '') => {
        set({ isLoading: true, error: null });

        try {
            const response = await axios.post(
                config.API_URL + 'bank/ignore/' + notificationId,
                { note: note },
                { headers: {'x-api-key': sessionStorage.getItem("apiKEY")} }
            );

            set({ isLoading: false });
            get().loadNotifications();
            return response.data;

        } catch (error) {
            set({ error: error.message, isLoading: false });
            throw error;
        }
    },

    updateNotification: async (notification) => {
        set({ isLoading: true, error: null });

        try {
            const response = await axios.post(
                config.API_URL + 'bank/notifications/' + notification.ID,
                notification,
                { headers: {'x-api-key': sessionStorage.getItem("apiKEY")} }
            );

            set({ isLoading: false });
            get().loadNotifications();
            return response.data;

        } catch (error) {
            set({ error: error.message, isLoading: false });
            throw error;
        }
    },

    refreshData: () => {
        get().loadNotifications()
    }

})

const useBankNotificationStore = create(BankNotificationStore)

export default useBankNotificationStore
